/** The article index and lazy article bodies, from the build (virtual:academy). */
import { ARTICLES, LOADERS, SCREENS } from 'virtual:academy';
import type { ArticleMeta, ArticleModule } from './types';

export { ARTICLES };
/** A screenshot's pixel size, when its image exists. */
export const screenSize = (name: string): readonly [number, number] | null => SCREENS[name] ?? null;

const BY_SLUG = new Map(ARTICLES.map((a) => [a.slug, a]));
export const articleBySlug = (slug: string): ArticleMeta | null => BY_SLUG.get(slug) ?? null;

const loaded = new Map<string, ArticleModule>();
const pending = new Map<string, Promise<ArticleModule>>();

/** The article's compiled body, once loaded (for rendering without a flash on revisits). */
export const loadedArticle = (slug: string) => loaded.get(slug) ?? null;

export function loadArticle(slug: string): Promise<ArticleModule> {
  const load = LOADERS[slug];
  if (!load) return Promise.reject(new Error(`No article "${slug}"`));
  let p = pending.get(slug);
  if (!p) {
    p = load().then((m) => (loaded.set(slug, m), m));
    pending.set(slug, p);
    p.catch(() => pending.delete(slug));
  }
  return p;
}
